/**
 * @author        julian@zumper.com (Julian Napolitan)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   MobileAutocompleteInputContainer
 */

import { memoMapDispatchToProps } from '@zcode/react-utils'
import type { Dispatch } from '@zcode/state-type'
import { connect } from 'react-redux'
import {
  setMobileOrigin,
  showMobileAutocomplete,
} from '../../../../shared/modules/autocomplete/actions'
import { type PageNameValues, trackSearchBarClick } from '../trackSearchBarClick'
import SharedMobileAutocompleteInput from './SharedMobileAutocompleteInput'

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: {
    mobileOrigin: 'nearme' | 'Bottom Search' | 'top-search' | null
    pageName?: PageNameValues
  }
) => {
  const { mobileOrigin, pageName } = ownProps
  return {
    onClick: () => {
      dispatch(showMobileAutocomplete())
      dispatch(setMobileOrigin(mobileOrigin))
      pageName && dispatch(trackSearchBarClick({ pageName }))
    },
  }
}

const equalProps = ['mobileOrigin' as const]

const memoSharedMobileAutocompleteInputDispatchToProps = memoMapDispatchToProps(
  mapDispatchToProps,
  equalProps
)

const SharedMobileAutocompleteInputContainer = connect(
  null,
  memoSharedMobileAutocompleteInputDispatchToProps
)(SharedMobileAutocompleteInput)

export default SharedMobileAutocompleteInputContainer
